import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import Get from '../../api/Get'
import Post from '../../api/Post'
import Put from '../../api/Put'
import { COUNTRY_ALL, COUNTRY_UPDATE } from "../../api/Routes";
import { COUNTRY_ADD } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import CountryList from "./country/CountryList";
import AddCountry from "./country/AddCountry";
import Filtro from '../../components/catalogos/Filtro';
import LoadingList from "../../loader/LoadingList";

import '../../styles/catalogos/catalogos.css'
import { toBool } from '../../utils/toBool';
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

function CountryIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    useEffect(() => cargarPaises(), [])

    const cargarPaises = () => {
        setLoading(true)

        Get({url: COUNTRY_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            setItems(resp.data.data.response.content)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const agregarPais = (values) => {
        values.active = true;
        values.companies = [auth.data.company]
        setLoading(true)
        Post({url: COUNTRY_ADD, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({name:''})            
            setLoading(false)            
        })                
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const editarPais = (values) =>{
        
        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }        

        Put({url: COUNTRY_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //OK
        })                
        .catch((error) => {
            setLoading(false)        
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            <Filtro catName ='Paises'/>
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddCountry agregarPais={agregarPais} initialValues={initialValues} />}
                </Col>
                <Col xs="6" md="6">
                    <CountryList items={items} 
                        editarPais={editarPais}
                        auth={auth}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default CountryIndex